/**
 * Returns a background color (or gradient) based on the day's usage and billing type.
 *
 * @param {{ usage: number | null; dayBillType: string | null } | null} day
 * - The day object containing usage and billing type information.
 * - If `day` is null/undefined or `usage` is null/undefined, a default error color is returned.
 *
 * @returns {string}
 * - A CSS color or gradient string representing the background:
 *   - "#FDE5E5" → when data is missing
 *   - "linear-gradient(...)" → for MIXED billing type
 *   - "#D0EFFD" → for INTERPOLATION or EXTRAPOLATION
 *   - "#CBF2AC" → for ACTUAL
 *   - "#FFFFFF" → fallback/default
 */
export const getBackgroundColor = (
  day: { usage: number | null; dayBillType: string | null } | null,
) => {
  if (
    day === null ||
    day === undefined ||
    day.usage === null ||
    day.usage === undefined
  )
    return "#FDE5E5";

  const { dayBillType } = day;

  if (dayBillType === "MIXED") {
    return "linear-gradient(to bottom right, #CBF2AC 50%, #D0EFFD 50%)";
  }

  if (dayBillType === "INTERPOLATION" || dayBillType === "EXTRAPOLATION") {
    return "#D0EFFD";
  }

  if (dayBillType === "ACTUAL") {
    return "#CBF2AC";
  }

  return "#FFFFFF";
};
